import React, { useEffect, useCallback } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { useSelector } from 'react-redux';

import { keyEnterSubmitForm } from '../../../../utilities/FormUtils';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Button from '../../../../control/button/Button';
import AutoComplete from '../../../../control/autocomplete/AutoComplete';
import TextFields from '../../../../control/textfield/TextFields';

const useStyles = makeStyles((theme) => ({
    spacing: {
        ...theme.form.spacing,
    },
    btnSearch: {
        width: '105px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    btnReset: {
        backgroundColor: `${theme.mainTheme.color6} !important`,
        width: '105px',
        marginRight: '8px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginRight: '0px',
            marginBottom: '2%',
        },
    },
    controlBtnContainer: {
        display: 'flex',
        flexDirection: 'row',
        marginTop: '8px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            marginTop: 0,
        },
    },
}));

const formId = 'EventDetailSearchForm';

const SearchForm = ({
    initialize,
    reset,
    change,
    defaultValues,
    lookups,
    showOrganization,
    onSubmit,
    handleChangePath,
    handleClickReset,
}) => {
    const classes = useStyles();
    const values = useSelector((state) => getFormValues(formId)(state));

    useEffect(() => {
        initialize({ ...defaultValues });
    }, []);

    const handleClickSearch = useCallback(() => {
        const _values = { ...values };
        if (!showOrganization) {
            delete _values.orgId;
        }
        onSubmit(_values);
    }, [showOrganization, onSubmit, values]);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} className={classes.spacing}>
                <Field
                    name="keyword"
                    label="ระบุ ชื่อ-นามสกุล, รหัสพนักงาน, อีเมล เพื่อค้นหา"
                    placeholder="ชื่อ - นามสกุล, รหัสพนักงาน, อีเมล"
                    component={TextFields}
                    maxLength={100}
                />
            </Grid>
            <Grid item xs={12} md={4} lg={4} className={classes.spacing}>
                <Field
                    name="registerType"
                    label="ประเภทการลงทะเบียน"
                    placeholder="ทั้งหมด"
                    component={AutoComplete}
                    options={lookups.registerType}
                    optionKey={{
                        value: 'value',
                        label: 'label',
                    }}
                    noSelectOption={'ทั้งหมด'}
                />
            </Grid>
            <Grid item xs={12} md={4} lg={4} className={classes.spacing}>
                <Field
                    name="isInternal"
                    label="ประเภทผู้เข้าร่วมกิจกรรม"
                    placeholder="ทั้งหมด"
                    component={AutoComplete}
                    options={lookups.attendeeType}
                    optionKey={{
                        value: 'value',
                        label: 'label',
                    }}
                    noSelectOption={'ทั้งหมด'}
                />
            </Grid>
            <Grid item xs={12} md={4} lg={4} className={classes.spacing}>
                <Field
                    name="company"
                    label="หน่วยงาน"
                    placeholder="ไม่ระบุ"
                    component={AutoComplete}
                    options={lookups.company}
                    optionKey={{
                        value: 'companyName',
                        label: 'companyName',
                    }}
                    isSameOptionKeyValue={true}
                />
            </Grid>
            <Grid item xs={12} md={4} lg={4} className={classes.spacing}>
                <Field
                    name="pathId"
                    label="สายงาน"
                    placeholder="ไม่ระบุ"
                    component={AutoComplete}
                    options={lookups.paths}
                    optionKey={{
                        value: 'pathId',
                        label: 'pathName',
                    }}
                    onChange={handleChangePath}
                />
            </Grid>
            <Grid item xs={12} md={4} lg={4} className={classes.spacing}>
                <Field
                    name="depId"
                    label="ฝ่าย"
                    placeholder="ไม่ระบุ"
                    component={AutoComplete}
                    options={lookups.departments}
                    optionKey={{
                        value: 'depId',
                        label: 'depName',
                    }}
                />
            </Grid>

            <Grid
                item
                xs={12}
                md={4}
                lg={4}
                alignItems="center"
                justifyContent="center"
                className={classes.controlBtnContainer}
            >
                <Button
                    className={classes.btnReset}
                    onClick={handleClickReset}
                    label="ค่าเริ่มต้น"
                />
                <Button
                    className={classes.btnSearch}
                    onClick={handleClickSearch}
                    label="ค้นหา"
                />
            </Grid>
        </Grid>
    );
};

export default reduxForm({
    form: formId,
})(SearchForm);
